import { useQuery } from '@tanstack/react-query';
import { useOrganization } from '@/contexts/OrganizationContext';
import { paymentRepository } from '../repositories/payment.repository';
import { paymentKeys } from '../services/payments.keys';
import type { DashboardPayments } from '../types/payment.types';

export type { DashboardPayments };

export function useDashboardPayments() {
  const { currentOrganization } = useOrganization();

  return useQuery<DashboardPayments>({
    queryKey: paymentKeys.dashboardPayments(currentOrganization?.id || ''),
    queryFn: async (): Promise<DashboardPayments> => {
      if (!currentOrganization?.id) {
        throw new Error('No current organization selected');
      }
      return paymentRepository.fetchDashboardPayments(currentOrganization.id);
    },
    enabled: !!currentOrganization?.id,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
